import { useEffect, useRef } from "react";
import PageLayout from "../../../PageLayout";
import { EButton } from "../../../libs/ui";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Avatar,
  BackgroundImage,
  Grid,
  Tabs,
} from "@mantine/core";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import usePatientVisit from "./hook/usePatientVisit";
import ClinicalHistoryForm from "./Pages/ClinicalHistory/Components/ClinicalHistoryForm";
import GallstonesForm from "./Pages/ClinicalHistory/Components/GallstonesForm";
import InvestigationForm from "./Pages/Investigation/Components/InvestigationForm";
import CostEffectiveAnalysis from "./Pages/CostEffectiveAnalysis/CostEffectiveAnalysis";
import { bgBodyColor } from "../../../DefaultValue";
import QualityOfLife from "./Pages/QualityOfLife/QualityOfLife";
import GBCClinicalPresentation from "./Pages/GBCClinicalPresentation/GBCClinicalPresentation";
import Radiology from "./Pages/Investigation/Components/Radiology";
import { PatientContext } from "../patientFromContext/PatientsContext";
import { camelCaseToTitleCase } from "../../../utils/utility";
import DyspepsiaSymptoms from "./Pages/ClinicalHistory/Components/DyspepsiaSymptoms";

export default function PatientVisit() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const patient_id = searchParams.get("patient_id");

  const {
    isBtnLoading,
    setIsBtnLoading,
    isBtnDisable,
    setIsBtnDisable,
    isFormUpdating,
    setIsFormUpdating,
    isBtnBackClick,
    setIsBackBtnClick,
    isBtnNextClick,
    setIsNextBtnClick,
    progress,
    setProgress,
    activeTab,
    setActiveTab,
    colorScheme,
    setColorScheme,
    handleNextTab,
    handleBackTab,
    tabsValue,
    activeSubTab,
    setActiveSubTab,
    patientDetails,
    fetchPatientDetails,
  } = usePatientVisit();

  const viewport = useRef<HTMLDivElement>(null);

  useEffect(() => {
    fetchPatientDetails();
  }, []);

  useEffect(() => {
    if (activeTab) {
      setColorScheme({ head: bgBodyColor[activeTab], body: bgBodyColor[activeTab] + 50, text: "", footer: "" })
    }
    else {
      setColorScheme({ head: "", body: "", text: "", footer: "" })
    }
  }, [activeTab])

  return (
    <PatientContext.Provider
      value={{
        activeTab,
        setActiveTab,
        activeSubTab,
        setActiveSubTab,
        isBtnDisable,
        setIsBtnDisable,
        isBtnLoading,
        setIsBtnLoading,
        progress,
        setProgress,
        isBtnBackClick,
        isBtnNextClick,
        handleBackTab,
        handleNextTab,
        isFormUpdating,
        setIsFormUpdating,
        colorScheme,
        setColorScheme,
      }}
    >
      <Tabs
        value={activeTab}
        variant="pills"
        onChange={(e) => {
          if (viewport.current && e == "investigation") {
            viewport.current.scrollTo({
              left: viewport.current.scrollWidth,
              behavior: "smooth",
            });
          }
          if (viewport.current && e == "anthropometric") {
            viewport.current.scrollTo({ left: 0, behavior: "smooth" });
          }
          setActiveTab(e ?? "");
          setActiveSubTab(1);
        }}
      >
        <PageLayout
          header={
            <BackgroundImage src={""} className="">
              <div className="flex justify-between items-center">
                <div className="flex flex-row items-end gap-4 p-4">
                  <Avatar size="xl" radius="sm" className="bg-white" />
                  <div className="flex flex-col">
                    <div className="text-2xl font-semibold">
                      {(patientDetails?.first_name || "") +
                        " " +
                        (patientDetails?.last_name || "")}
                    </div>
                    <div className="text-base font-medium text-slate-600">
                      {patientDetails?.primary_contact_no || "+91____________"}
                    </div>
                  </div>
                </div>
                <div className="self-start pt-4">
                  {/* <p className="text-slate-400 text-xl">You are in Visit: 1</p> */}
                  <EButton
                    size="md"
                    onClick={() => navigate(`/index/patient/details?patient_id=${patient_id}`)}
                  >
                    <BsArrowLeft /> Back
                  </EButton>
                </div>
              </div>
              <div className="flex gap-1 items-center">
                <FaChevronLeft
                  className="cursor-pointer"
                  onClick={() =>
                    viewport.current &&
                    viewport.current.scrollTo({ left: 0, behavior: "smooth" })
                  }
                />
                <Tabs.List
                  style={{
                    flexWrap: "nowrap",
                    overflowX: "scroll",
                    marginBottom: "-15px",
                  }}
                  ref={viewport}
                >
                  {
                    tabsValue?.map((tab) => (
                      <Tabs.Tab
                        value={tab.label}
                        disabled={tab.disable}
                      >
                        {camelCaseToTitleCase(tab.label?.replaceAll("_", " "))}
                      </Tabs.Tab>
                    ))
                  }
                </Tabs.List>

                <FaChevronRight
                  className="cursor-pointer mx-2"
                  onClick={() =>
                    viewport.current &&
                    viewport.current.scrollTo({
                      left: viewport.current.scrollWidth,
                      behavior: "smooth",
                    })
                  }
                />
              </div>
            </BackgroundImage>
          }
          footer={
            <div className="p-2 flex items-center justify-end gap-2">
              {/* <EButton 
                className="btn-blue"
                size="md"
                disabled={activeTab === "personal_history" ? true : false}
                onClick={() => {
                  handleBackTab()
                  setIsBackBtnClick(!isBtnBackClick)
                }
                }
              >
                Back
              </EButton> */}
              <EButton
                className="btn-blue"
                size="md"
                // disabled={activeTab ==="clinical_history" || isBtnDisable}
                loading={isBtnLoading}
                onClick={() => {
                  setIsNextBtnClick(!isBtnNextClick);
                  setTimeout(() => {
                    setIsNextBtnClick(false);
                  }, 100);
                }}
              >
                {isFormUpdating ? "Update" : "Submit"}
              </EButton>
            </div>
          }
        >
          <Grid>
            <Grid.Col span={12} className="pr-5  mt-4">
              <Tabs.Panel value="clinical_history">
                <ClinicalHistoryForm />
              </Tabs.Panel>

              <Tabs.Panel value="gallstone">
                <GallstonesForm />
              </Tabs.Panel>

              <Tabs.Panel value="dyspepsia_symptoms">
                <DyspepsiaSymptoms />
              </Tabs.Panel>

              {/* <Tabs.Panel value="gbc_clinical_presentation">
                <GBCClinicalPresentation />
              </Tabs.Panel> */}

              <Tabs.Panel value="investigation">
                <InvestigationForm />
              </Tabs.Panel>

              <Tabs.Panel value="radiology">
                {/* <ImageAndCharacteristicsOfGB /> */}
                <Radiology />
              </Tabs.Panel>

              <Tabs.Panel value="cost_effective_analysis">
                <CostEffectiveAnalysis />
              </Tabs.Panel>
              <Tabs.Panel value="quality_of_life">
                <QualityOfLife />
              </Tabs.Panel>
            </Grid.Col>
          </Grid>
        </PageLayout>
      </Tabs>
    </PatientContext.Provider>
  );
}
